<script>
import Icon from "@/components/atoms/icon";

export default {
  name: "ContactInfoCorapro",
  components: { Icon },
  props: {
    contact: {
      type: Object,
      required: false,
      default: () => {}
    },
    isHomePage: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <div
    class="c-contact-infos-corapro"
  >
    <div class="c-contact-infos-corapro__item">
      <Icon
        variant="primary"
        name="commercial-pro"
        :size="isHomePage ? 'xxlg' : 'xlg'"
      />
      <span
        class="u-ml-sm"
        :class="isHomePage ? 'u-font-22': 'u-font-20'"
      >
        {{ contact.prenom_referent }} {{ contact.nom_referent }}
      </span>
    </div>
    <template v-if="isHomePage">
      <div
        v-if="contact.tel_referent"
        class="c-contact-infos-corapro__item"
      >
        <Icon
          variant="primary"
          name="phone"
          :size="isHomePage ? 'xxlg' : 'xlg'"
        />
        <span
          class="u-ml-sm"
          :class="isHomePage ? 'u-font-22': 'u-font-20'"
        >
          <a :href="`tel:${contact.tel_referent}`">{{ contact.tel_referent }}</a>
        </span>
      </div>
      <div
        v-if="contact.mobile_referent"
        class="c-contact-infos-corapro__item"
      >
        <Icon
          variant="primary"
          name="smartphone"
          :size="isHomePage ? 'xxlg' : 'xlg'"
        />
        <span
          class="u-ml-sm"
          :class="isHomePage ? 'u-font-22': 'u-font-20'"
        >
          <a :href="`tel:${contact.mobile_referent}`">{{ contact.mobile_referent }}</a>
        </span>
      </div>
    </template>
    <div
      v-else
      class="c-contact-infos-corapro__phones"
    >
      <div
        v-if="contact.tel_referent"
        class="c-contact-infos-corapro__item"
      >
        <Icon
          variant="primary"
          name="phone"
          size="xlg"
        />
        <span class="u-ml-sm u-font-20">
          <a :href="`tel:${contact.tel_referent}`">{{ contact.tel_referent }}</a>
        </span>
      </div>
      <div
        v-if="contact.mobile_referent"
        class="c-contact-infos-corapro__item"
      >
        <Icon
          variant="primary"
          name="smartphone"
          size="xlg"
        />
        <span class="u-ml-sm u-font-20">
          <a :href="`tel:${contact.mobile_referent}`">{{ contact.mobile_referent }}</a>
        </span>
      </div>
    </div>
    <div class="c-contact-infos-corapro__item">
      <Icon
        variant="primary"
        name="email"
        :size="isHomePage ? 'xxlg' : 'xlg'"
      />
      <span
        class="u-ml-sm"
        :class="isHomePage ? 'u-font-22': 'u-font-20'"
      >
        <a :href="`mailto:${contact.mail_referent}`">{{ contact.mail_referent }}</a>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-contact-infos-corapro {
  margin-left: calc((100% / 12) * 1);
  margin-right: calc((100% / 12) * 1);
  display: flex;
  justify-content: space-around;
  gap: spacing(xs);
}
.c-contact-infos-corapro__item {
  display: flex;
  align-items: center;
}
.c-contact-infos-corapro__phones {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

@include mq(bp(lg)) {
  .c-contact-infos-corapro {
    display: block;
  }
}
</style>
